export const validatePrices = (priceList)=>{
  if(!priceList || Object.keys(priceList).length === 0) return [];

  let invalidIndexes = [];
  priceList.forEach((row, index)=> {

    // console.log('row');
    // console.log(row);
    // console.log('price type');
    // console.log(typeof row.price);
    // console.log('row price');
    // console.log(row.price);


    //if(!row.price || (typeof row.price !== 'number' && isNaN(row.price)) ) {
    if(typeof row.price !== 'number' && isNaN(row.price) ) {

      console.log('invalid row');
      invalidIndexes.push(index);

    }
  });
  return  invalidIndexes;
};
